import { Component, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { faFacebookF, faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { IconComponent } from '@infodocs/shared/components/icon/icon.component';
import { AccountService } from '@infodocs/shared/services/account.service';
import { AuthService } from '@infodocs/shared/services/auth.service';


@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
	imports: [IconComponent]
})
export class FooterComponent {
	protected readonly blogUrl = environment.blogUrl;
	protected readonly helpCentreUrl = environment.helpCentreUrl;
	protected readonly facebookIcon = faFacebookF;
	protected readonly xIcon = faXTwitter;
	protected readonly linkedInIcon = faLinkedinIn;
	protected readonly auth = inject(AuthService);
	protected readonly accountService = inject(AccountService);
	protected readonly currentYear = new Date().getFullYear();
}
